module.exports = __webpack_public_path__ + "media/svg/img-iphone-97ed0865.jpg";